module.exports = __webpack_public_path__ + "static/img/subscribe.2020f812.png";